module.exports = __webpack_public_path__ + "img/img_notfound.8cf5a3c8.png";